const adsenseAdsTemplate = require('../../footer.html.mustache');

class AdsenseForSearchView {
  constructor({ el }) {
    this.elementSelector = document.querySelector(el);
  }

  render(adsenseAdsHash) {
    return (this.elementSelector.innerHTML = adsenseAdsTemplate.render({
      adsenseAdsHash,
    }));
  }

  loadAds(query, currentPage) {
    const adsenseAdsContainerEl = this.elementSelector.querySelector(
      '#adsense-ads-container'
    );
    if (!adsenseAdsContainerEl) {
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    if (adsenseAdsContainerEl.length === 0 || window._googCsa == null) {
      return;
    }

    const elementOptions = {
      container: 'adsense-ads-container',
      width: '1000',
      number: 4,
      colorDomainLink: '0088CC',
      colorText: '333333',
      colorTitleLink: '0088CC',
      adLayout: 'sellerFirst',
      longerHeadlines: false,
      detailedAttribution: true,
    };

    const pageOptions = {
      adPage: currentPage,
      pubId: 'livingsocial',
      query,
      adtest: true,
      domainLinkAboveDescription: false,
      location: true,
      sellerRatings: false,
      consumerRatings: false,
      siteLinks: true,
      linkTarget: '_blank',
      adLoadedCallback(containerName, adsLoaded) {
        if (adsLoaded) {
          adsenseAdsContainerEl.removeClass('hide-ads');
        } else {
          adsenseAdsContainerEl.addClass('hide-ads');
        }
      },
    };

    // eslint-disable-next-line no-underscore-dangle
    window._googCsa('ads', pageOptions, elementOptions);
  }
}

module.exports = AdsenseForSearchView;
